















































import Vue from 'vue';
import { ChildType } from '../types/interface';
import PointPagination from './pointPagination.vue';
export default Vue.extend({
    components: {
        PointPagination
    },
    data() {
        return {
        };
    },
    props: {
        pointListOptions: {
            type: Array,
            default: [],
        },
        pointDetailOption: {
            type: Object,
            default: (): any => {
                return {
                    childValueTyleOptions: [],
                    periodOptions: [],
                    aggregateOptions: [],
                    periodAggregateOption: [],
                }
            },
        },
        showTootip: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        childValueTyleOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.childValueTyleOptions;
        },
        periodOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.periodOptions;
        },
        aggregateOptions(): any[] {
            return this.pointDetailOption && this.pointDetailOption.aggregateOptions;
        },
        periodAggregateOption(): any[] {
            return this.pointDetailOption && this.pointDetailOption.periodAggregateOption;
        },
    },
    methods: {
        findLabel(propOptions: any[], targetProp: string): string {
            const { length } = propOptions;
            let labelName = '';
            if (length) {
                const labelItem = propOptions.find( (option: {value: string, label: string}) => {
                    return option.value === targetProp;
                });
                labelName = labelItem && labelItem.label || '';
            }
            return labelName;
        },
        transformLabel(point) {
            const childValueTyleLabel = this.findLabel(this.childValueTyleOptions, point.childValueTyle);
            const periodLabel = this.findLabel(this.periodOptions, point.period);
            const aggregateLabel = this.findLabel(this.aggregateOptions, point.aggregate);
            const periodAggregateLabel = this.findLabel(this.periodAggregateOption, point.periodAggregate);

            let checkPointLabel = '';
            switch (point.childValueTyle) {
                case ChildType.Statistics:
                    checkPointLabel = `_${childValueTyleLabel}_${periodAggregateLabel}`;
                    break;
                case ChildType.EngineValue:
                    checkPointLabel = `_${childValueTyleLabel}_${periodLabel}_${aggregateLabel}`;
                    break;
            }
            return checkPointLabel;
        },
        changePage(pageNum: number): void {
            console.log(pageNum);
        }
    },
})
